export var GraveSearchEnum;
(function (GraveSearchEnum) {
    GraveSearchEnum["Cemetery"] = "Cemetery";
    GraveSearchEnum["PlotNumber"] = "Plot number";
    GraveSearchEnum["GraveId"] = "Grave Id";
    GraveSearchEnum["GraveStatus"] = "Grave status";
    GraveSearchEnum["Capacity"] = "Grave capacity";
    GraveSearchEnum["MarkerType"] = "Marker type";
})(GraveSearchEnum || (GraveSearchEnum = {}));
